var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"md-layout"},[_c('md-card',{staticClass:"md-layout-item md-size-66 md-medium-size-100",staticStyle:{"margin":"0 auto"}},[_c('badges')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }